import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {supportDetails} from "../../util/ApiUtils";
import {withStyles} from "@material-ui/styles";
import {Spinner} from "../common/Spinner";
import Ims from "./ImsProcedure";
import MmResources from "./MmResources";
import DocumentedInformation from "./DocumentedInformation";
import OperationProcedure from "./OperationProcedure";
import Training from "./Training";
import PropertyBelonging from "./PropertyBelonging";
import InternalAuditProcedure from "./InternalAuditProcedure";
import NonconformityProcedure from "./NonconformityProcedure";
import ContinualImprovementProcedure from "./ContinualImprovementProcedure";
import PersonalProtectiveEquipmentProcedure from "./PersonalProtectiveEquipmentProcedure";
import RiskAssessmentProcedure from "./RiskAssessmentProcedure";
import OnSiteInductionProcedure from "./OnSiteInductionProcedure";
import IncidentNotificationProcedure from "./IncidentNotificationProcedure";
import IncidentInvestigationProcedure from "./IncidentInvestigationProcedure";
import MeasurementAndTraceability from "./MeasurementAndTraceability";
import OrganisationalKnowledge from "./OrganisationalKnowledge";
import Competence from "./Competence";
import AwarenessOfIms from "./AwarenessOfIms";
import Communication from "./Communication";
import {Preservation} from "./Preservation";
import {PostDeliveryActivities} from "./PostDeliveryActivities";
import {IncidentDescription} from "./IncidentDescription";
import DocumentControlHeader from "./DocumentControlHeader";

const classes = () => ({
    card: {
        width: '100%',
    },
});

class Support extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latestRevision: {},
            isLoading: true,
        };
        this.loadSupportDetails = this.loadSupportDetails.bind(this);
    }

    componentDidMount() {
        this.loadSupportDetails();
    }

    loadSupportDetails() {
        supportDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    support: response,
                    orgId: response.id,
                    latestRevision: response.latestRevisionDto,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        let { state } = this;
        const { classes } = this.props;

        if (state.isLoading) {
            return <Spinner/>;
        }

        return <div className="mui-container-fluid">
                <Route path={`/support/ims`}
                       render={() => <Ims currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/mm-resources`}
                       render={() => <MmResources currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/measurement-and-traceability`}
                       render={() => <MeasurementAndTraceability currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/org-knowledge`}
                       render={() => <OrganisationalKnowledge currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/competence`}
                       render={() => <Competence currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/awareness`}
                       render={() => <AwarenessOfIms currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/communication`}
                       render={() => <Communication currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/documented-information`}
                       render={() => <DocumentedInformation currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/operation`}
                       render={() => <OperationProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/training`}
                       render={() => <Training currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/property-belonging`}
                       render={() => <PropertyBelonging currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/preservation`}
                       render={() => <Preservation currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/post-delivery`}
                       render={() => <PostDeliveryActivities currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/internal-audit`}
                       render={() => <InternalAuditProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/nonconformity`}
                       render={() => <NonconformityProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/continual-improvement`}
                       render={() => <ContinualImprovementProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/ppe`}
                       render={() => <PersonalProtectiveEquipmentProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/risk-assessment`}
                       render={() => <RiskAssessmentProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/on-site-induction`}
                       render={() => <OnSiteInductionProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/incident-notification`}
                       render={() => <IncidentNotificationProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/description-of-the-incident`}
                       render={() => <IncidentDescription currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
                <Route path={`/support/incident-investigation`}
                       render={() => <IncidentInvestigationProcedure currentUser={this.props.currentUser} revision={state.latestRevision}/>}
                />
        </div>;
    }
}

export default withStyles(classes)(Support);